<!--
 * @Date: 2022-07-28 11:26:41
 * @LastEditors: lizixuan 240514049@qq.com
 * @LastEditTime: 2022-08-01 17:17:20
 * @FilePath: \hw_game_mp_gamebrain_data\frontend\src\components\V1\SendMessage.vue
 * @Description: 
-->
<template>
  <a-modal :visible="showDialog" :mask="true" :maskClosable="false" :title="title" @ok="handleOk"
    @cancel="handleCancel()">
    <a-spin :spinning="loadding" tip="Loading...">
      <a-form  layout="vertical">
        <a-form-model-item label="消息类别" required>
          <a-radio-group v-model="dataInfo.isSystem">
            <a-radio value="1">
              系统消息
            </a-radio>
            <a-radio value="2">
              其他消息
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="消息类型" required>
          <a-checkbox-group v-model="dataInfo.mode">
            <a-checkbox value="socket" name="mode">
              站内信
            </a-checkbox>
            <a-checkbox value="mail" name="mode">
              邮件
            </a-checkbox>
            <a-checkbox value="feishu" name="mode">
              飞书消息
            </a-checkbox>
          </a-checkbox-group>
        </a-form-model-item>
        <a-form-model-item label="收信群体" required>
          <a-radio-group v-model="dataInfo.type" @change="changeType()">

            <a-radio value="all">
              所有人
            </a-radio>
            <a-radio value="system">
              GB用户
            </a-radio>
            <a-radio value="user">
              用户
            </a-radio>
            <a-radio value="group">
              用户组
            </a-radio>
          </a-radio-group>
        </a-form-model-item>
        <a-form-model-item label="收信用户" v-if="dataInfo.type == 'user'" required>
          <a-select v-model="dataInfo.userIds" style="width: 400px" allowClear :maxTagCount="4" placeholder="请选择接收消息的用户"
            mode="multiple" optionFilterProp="label">
            <a-select-option v-for="userItem in userList" :label="userItem.name" :value="userItem.id"
              :key="userItem.id">
              {{ userItem.name }}
            </a-select-option>
          </a-select>
        </a-form-model-item>
        <a-form-model-item label="收信用户组" v-if="dataInfo.type == 'group'" required>
          <a-tree-select v-model="dataInfo.group" style="width: 100%"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }" :tree-data="groupList" allow-clear
            placeholder="请选择用户组" treeNodeFilterProp="real_name" show-search tree-default-expand-all
            :replaceFields="{ children: 'children', title: 'real_name', key: 'name', value: 'name' }">
          </a-tree-select>
        </a-form-model-item>
        <a-form-model-item label="消息内容" required>
          <a-input v-model="dataInfo.content" type="textarea" />
        </a-form-model-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
import { GetUserAll } from "../../api/v1/user_api";
import { SocketSend } from "../../api/v1/message_api";
import { GetGroupTree } from "../../api/v1/group_api";
export default {
  name: "SendMessage",
  props: ['showDialog'],
  data() {
    return {
      dataInfo: {
        content: '',
        isSystem: "1",
        type: "system",
        mode: ['socket'],
        group: '',
        userIds: [],
      },
      userList: [],
      groupList: [],
      title: '发送消息',
      loadding: false
    }
  },
  methods: {
    handleOk() {
      if (!this.dataInfo.isSystem) {
        this.$message.error('请选择消息类别')
        return
      }
      if (this.dataInfo.mode.length == 0) {
        this.$message.error('请选择消息类型')
        return
      }
      if (!this.dataInfo.userIds) {
        this.$message.error('请选择收信群体')
        return
      }

      if (this.dataInfo.type == 'user' && this.dataInfo.userIds.length == 0) {
        this.$message.error('请选择收信用户')
        return
      }
      if (this.dataInfo.type == 'group' && !this.dataInfo.group) {
        this.$message.error('请选择收信用户组')
        return
      }
      if (!this.dataInfo.content) {
        this.$message.error('请填写消息内容')
        return
      }

      this.loadding = true
      SocketSend(this.dataInfo).then(resp => {
        if (resp.code === 200) {
          
          this.loadding = false
          this.$message.success(resp.msg)
          this.handleCancel()
        } else {
          this.loadding = false
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel() {
      this.dataInfo = {
        'content': '',
        'isSystem': "1",
        'type': "system",
        'mode': ['socket'],
        'group': '',
        'userIds': [],
      }
      this.$emit('close-dialog')
    },
    changeType() {
      this.dataInfo.userIds = []
      this.dataInfo.group = ''
      if (this.dataInfo.type == 'user') {
        GetUserAll({}).then(resp => {
          if (resp.code === 200) {
            this.userList = resp.data
          } else {
            this.$message.error(resp.msg)
          }
        })
      }
      if (this.dataInfo.type == 'group') {
        GetGroupTree({}).then(resp => {
          if (resp.code === 200) {
            this.groupList = resp.data
          } else {
            this.$message.error(resp.msg)
          }
        })
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/V1/SendMessage.vue